import { AloCodicSection } from './AloCodicSection'

export interface AloCodicInfoTree {    
    offersSections:Array<AloCodicSection>
    productSections:Array<AloCodicSection>
    message:string
}

export const getDefaultAloCodicInfoTree = ():AloCodicInfoTree => {
    return {                
        offersSections:[],
        productSections:[],
        message:''
    }
}